var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatListNumberedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3 22v-1.5h2.5v-.75H4v-1.5h1.5v-.75H3V16h3a.97.97 0 0 1 .713.288A.97.97 0 0 1 7 17v1a.97.97 0 0 1-.287.712A.97.97 0 0 1 6 19a.97.97 0 0 1 .713.288A.97.97 0 0 1 7 20v1a.97.97 0 0 1-.287.712A.97.97 0 0 1 6 22zm0-7v-2.75a.97.97 0 0 1 .288-.713A.97.97 0 0 1 4 11.25h1.5v-.75H3V9h3q.424 0 .713.287Q7 9.575 7 10v1.75q0 .424-.287.713A.97.97 0 0 1 6 12.75H4.5v.75H7V15zm1.5-7V3.5H3V2h3v6zM9 19v-2h12v2zm0-6v-2h12v2zm0-6V5h12v2z"
}))));
export default SvgFormatListNumberedIcon;